import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useConfigurationStorage } from '@data';
import { getBrandName } from '@utils-global';

export const useDocumentTitle = (isI18NextInitialized: boolean) => {
  const { t } = useTranslation();
  const { configuration } = useConfigurationStorage();

  useEffect(() => {
    if (isI18NextInitialized) {
      document.title = getBrandName(configuration, t);
    }
  }, [configuration, isI18NextInitialized, t]);
};
